import { render, staticRenderFns } from "./PicPay.vue?vue&type=template&id=45507e74&"
import script from "./PicPay.vue?vue&type=script&lang=js&"
export * from "./PicPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports